// extracted by mini-css-extract-plugin
module.exports = {"placeholderText":"File_placeholderText__ld2lt","textAnnotation":"File_textAnnotation__ZUKIr"};